<template>
  <div id="intro" class="destination-intro push-v--desktop--small push-v--tablet--small push-v--mobile--small">
    <section class="container destination-intro--wrapper">
      <div class="destination-intro--main-content">
        <h1 class="destination-intro--title">{{ title }}</h1>
        <div class="destination-intro--intro">{{ description }}</div>
        <div class="destination-intro--public-transport-title">Public transport</div>
        <div class="destination-intro--public-transport">
          <div v-for="(item, index) in publicTransport" :key="index" class="destination-intro--public-transport-item">
            <div class="destination-intro--duration">{{ item.duration }} min</div>
            <div class="destination-intro--location">{{ item.location }}</div>
          </div>
        </div>
      </div>
      <div class="destination-intro--side-content">
        <div class="destination-intro--images">
          <div ref="image1" class="destination-intro--image">
            <img :src="image1[0].url">
          </div>
          <div ref="image2" class="destination-intro--image">
            <img :src="image2[0].url">
          </div>
        </div>

        <div class="destination-intro--cta" @click="scrollToTopPicks">
          <div class="destination-intro--cta-arrow" />
          <!-- <a :href="ctaLink">{{ ctaText }}</a> -->
          <span>{{ ctaText }}</span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { gsap, CSSPlugin } from 'gsap';
import debounce from 'lodash.debounce';

export default {
  setup() {

  },
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    description: {
      type: String,
      default: '',
      required: true,
    },
    ctaLink: {
      type: String,
      default: '',
      required: true,
    },
    ctaText: {
      type: String,
      default: '',
      required: true,
    },
    ctaAnchorLinkId: {
      type: String,
      default: 'members-top-picks',
      required: true,
    },
    publicTransport: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    image1: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    image2: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      scroller1: null,
      scroller2: null,
    };
  },
  mounted() {
    gsap.registerPlugin(CSSPlugin);
    gsap.registerPlugin(ScrollTrigger);

    this.debouncedResize = debounce(this.handleResize, 100);
    window && window.addEventListener('resize', this.debouncedResize);

    this.animate();
  },
  methods: {
    animate() {
      const { image1, image2 } = this.$refs;

      this.scroller1 = gsap.to(image1, {
        y: -100,
        scrollTrigger: {
          trigger: image1,
          scrub: true,
        },
      });

      this.scroller2 = gsap.to(image2, {
        y: 70,
        scrollTrigger: {
          trigger: image2,
          scrub: true,
        },
      });
    },
    handleResize() {
      this.scroller1.scrollTrigger.kill();
      this.scroller2.scrollTrigger.kill();
      this.animate();
    },
    scrollToTopPicks() {
      if (this.ctaLink) {
        window.location = this.ctaLink;
      } else if (this.ctaAnchorLinkId) {
        const ele = document.getElementById(this.ctaAnchorLinkId);
        ele.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_destination-intro.scss';
</style>
